import { Check, Loader2 } from "lucide-react";

export type ValidateFooterProps = {
  isGenerating: boolean;
  isAudioProcessing: boolean;
  isRemixing: boolean;
  onValidate: () => void;
};

export function ValidateFooter({
  isGenerating,
  isAudioProcessing,
  isRemixing,
  onValidate,
}: ValidateFooterProps) {
  return (
    <div className="flex items-center justify-end gap-3 border-t border-[#e2e8f0] px-5 py-3">
      {isGenerating && (
        <span className="flex items-center gap-1.5 text-[13px] text-[#64748b]">
          <Loader2 className="h-3.5 w-3.5 animate-spin" /> Génération…
        </span>
      )}
      <button
        type="button"
        onClick={onValidate}
        disabled={isGenerating || isAudioProcessing || isRemixing}
        className="inline-flex h-[38px] items-center gap-1.5 rounded-[12px] bg-[#007aff] px-5 text-[14px] font-medium text-white hover:bg-[#006ae0] disabled:opacity-50"
      >
        {isGenerating ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
        ) : (
          <Check className="h-3.5 w-3.5" />
        )}
        Valider version finale
      </button>
    </div>
  );
}
